import React, { Component } from 'react'

export default class Error extends Component {
    render() {
        return (
            <div>
                <h1>Oops! Page Not Found</h1>
            </div>
        )
    }
}
